/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VehicleListResponse } from '../../models/vehicle-list-response';

export interface GetVehicles$Params {

/**
 * Pagination parameter. Skips page * size entries.
 */
  page?: number;

/**
 * Max number of results per page.
 */
  size?: number;

/**
 * Paramter to sort by as field(:(asc|desc))?. If missing default sort is used. field is the name in the db model not the db field name.
 */
  sort?: Array<string>;

/**
 * If true only vehicles without device association will be returned.
 */
  unassociated_only?: boolean;

/**
 * If true only vehicles currently on active tour will be returned.
 */
  currently_on_tour?: boolean;

/**
 * If true last location of vehicle will be included in response.
 */
  include_last_location?: boolean;
}

export function getVehicles(http: HttpClient, rootUrl: string, params?: GetVehicles$Params, context?: HttpContext): Observable<StrictHttpResponse<VehicleListResponse>> {
  const rb = new RequestBuilder(rootUrl, getVehicles.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {"style":"form","explode":true});
    rb.query('size', params.size, {"style":"form","explode":true});
    rb.query('sort', params.sort, {"style":"form","explode":true});
    rb.query('unassociated_only', params.unassociated_only, {"style":"form","explode":true});
    rb.query('currently_on_tour', params.currently_on_tour, {"style":"form","explode":true});
    rb.query('include_last_location', params.include_last_location, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VehicleListResponse>;
    })
  );
}

getVehicles.PATH = '/api/v1/vehicles';
